<template>
  <div class="middle-pannel">
    <div class="pannel-show">
      <div class="pannel-item" v-for="(item, index) in dataArray" :key="index">
        <div class="name">{{ item.name }}</div>
        <div class="text">{{ setVal(item.key) || "-" }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="box" style="margin-bottom: 20px;">
      <div
        class="box_title"
        :class="{
          active: index == itemIndex,
          isDisplay: index == 0 && isShowMinor,
        }"
        v-for="(item, index) in titleList"
        @pointerdown="sendDate(index)"
        :key="index"
      >
        {{ item.titleName }}
      </div>
    </div>
    <div class="bottom_content">
      <div v-if="itemIndex == 0">
        <slot></slot>
      </div>
      <div class="equ" v-if="itemIndex == 1">
        <div
          class="equList"
          :class="{ bg: index % 2 == 0 }"
          v-for="(item, index) in equList"
          :key="index"
        >
          <div class="text">{{ item.name }}</div>
          <div class="value">{{ setVal(item.value) || "-" }}</div>
        </div>
      </div>
      <div class="equ" v-if="itemIndex == 2">
        <div
          class="equList"
          :class="{ bg: index % 2 == 0 }"
          v-for="(item, index) in mainList"
          :key="index"
        >
          <div class="text">{{ item.name }}</div>
          <div class="value">{{ setVal(item.value) || "-" }}</div>
        </div>
      </div>
      <div class="repair" v-if="itemIndex == 3">
        <el-timeline :reverse="false">
          <el-timeline-item
            v-for="(item, index) in maintenanceRecord"
            :key="index"
            :timestamp="item.problem"
          >
            {{ item.completionTime || "-" }}
            <span style="margin-left:20px">{{ item.serviceman || "-" }}</span>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pannelDatas: Object,
    isShowMinor: Boolean,
  },
  data() {
    return {
      isDisabled: false,
      itemIndex: this.isShowMinor ? 1 : 0,
      titleList: [
        { id: 1, titleName: "监测" },
        { id: 2, titleName: "设备" },
        { id: 3, titleName: "维保" },
        { id: 4, titleName: "维修" },
      ],
      dataArray: [
        {
          name: "运行时间",
          key: "usedTime",
        },
        {
          name: "正常率",
          key: "percent",
        },
        {
          name: "故障时间",
          key: "faultTime",
        },
        {
          name: "故障次数",
          key: "faultCount",
        },
        // {
        //   name: "维修记录",
        //   key: "percent",
        // },
      ],
      // 设备
      equList: [
        { name: "设备编码", value: "eqpCode" },
        { name: "设备品牌", value: "eqpFactory" },
        { name: "设备型号", value: "eqpModel" },
        { name: "安装日期", value: "eqpInstallDate" },
        { name: "出厂日期", value: "eqpMfgDate" },
        { name: "安装地点", value: "installPos" },
      ],
      // 维保
      mainList: [
        { name: "联系人", value: "upkeepMan" },
        { name: "单位", value: "upkeepUnit" },
        { name: "电话", value: "upkeepTel" },
        { name: "结束时间", value: "upkeependTime" },
      ],
      repairList: [],
    };
  },
  computed: {
    maintenanceRecord() {
      return this?.pannelDatas?.maintenanceRecord;
    },
  },
  methods: {
    setVal(val) {
      if (val && this.pannelDatas) {
        if (this.pannelDatas?.[val] == "0") {
          return '0'
        }
        return this.pannelDatas?.[val];
      }
    },
    sendDate(index) {
      // if (index == 3 && this.pannelDatas.maintenanceRecord.length == 0) {
      //   return;
      // }
      this.itemIndex = index;
    },
  },

  watch: {
    pannelDatas: {
      immediate: true,
      handler(newval) {
        if (newval) {
          if (newval?.maintenanceRecord?.length > 0) {
            this.pannelDatas.maintenanceRecord = newval?.maintenanceRecord;
          } else {
            this.pannelDatas.maintenanceRecord = this.repairList;
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.isDisplay {
  display: none !important;
}
.dis-btn {
  pointer-events: none;
}

.middle-pannel {
  padding: 0 20px;
  margin-top: 8px;

  .line {
    margin: 11px 0;
    width: 341px;
    height: 1px;
    background-image: url("../../../assets/cut/xian.png");
    background-size: cover;
    background: rgba(0, 0, 0, 0.2);
  }

  .pannel-show {
    display: grid;
    grid-template-columns: 208px 123px;
    gap: 10px;
    // padding-left: 10px;
  }

  .pannel-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 8px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;

    .name {
      width: 56px;
      height: 21px;
      font-size: 14px;
      line-height: 21px;
      color: rgba(239, 239, 239, 0.7);
    }

    .text {
      height: 18px;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #fff;
    }
  }

  .box {
    width: 192px;
    height: 29px;
    border: 1px solid rgba(45, 130, 255, 0.4);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    .box_title {
      cursor: pointer;
      border-right: 1px solid rgba(45, 130, 255, 0.4);
      flex: 1;
      text-align: center;
      line-height: 29px;
      height: 29px;
      font-size: 14px;
    }

    .box_title:last-child {
      border-right: none;
    }

    .active {
      background-color: rgba(45, 130, 255, 0.4);
    }
  }

  /**/
  .detail {
    // display: grid;
    // grid-template-columns: 160px 160px;
    // grid-template-rows: repeat(5, 29px);
    // gap: 4px 20px;
    // overflow: hidden;

    // .contentList {
    //   padding: 4px 10px;
    //   display: flex;
    //   justify-content: space-between;
    //   width: 160px;
    //   font-size: 14px;
    //   color: rgba(239, 239, 239, 0.7);
    //   background: linear-gradient(
    //   270deg,
    //   rgba(0, 0, 0, 0) 0%,
    //   rgba(0, 0, 0, 0.2) 100%
    // );

    //   .value {
    //     color: #fff;

    //     span {
    //       color: rgba(239, 239, 239, 0.7);
    //     }
    //   }
    // }
  }

  .equ {
    .equList {
      display: flex;
      width: 341px;
      height: 25px;
      padding: 2px 10px;
      margin-bottom: 4px;
      font-size: 14px;
      color: rgba(239, 239, 239, 0.7);

      .text {
        width: 80px;
        margin-right: 20px;
      }
      .value {
        color: #fff;
      }
    }

    .bg {
      background: linear-gradient(
        270deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.2) 100%
      );
    }
  }

  .repair {
    ::v-deep .el-timeline-item__node--normal {
      width: 6px;
      height: 6px;
      left: 2px;
    }

    ::v-deep .el-timeline-item__content {
      color: #fff;
    }

    ::v-deep .el-timeline-item__timestamp {
      margin-top: 2px;
      padding-left: 10px;
      width: 284px;
      height: 22px;
      line-height: 22px;
      background: linear-gradient(
        270deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.2) 100%
      );
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    ::v-deep .el-timeline-item {
      padding-bottom: 10px;
    }
  }

  /**/

  .name-detail {
    color: rgba(239, 239, 239, 0.7) !important;
    padding-left: 10px;
  }

  .pannel-off {
    background: linear-gradient(
      270deg,
      rgba(0, 137, 255, 0) -1.46%,
      rgba(23, 110, 237, 0.25) 108.48%
    );
    // border: 1px solid ;
  }

  .pannel-btn {
    background-image: url("../../../assets/cut/show.png");
    background-size: cover;
    width: 356px;
    height: 12px;
    cursor: pointer;
  }

  .pannel-btns {
    background-image: url("../../../assets/cut/shows.png") !important;
  }
}
</style>
